<template>
  <div>
    <DrInfoTop/>
    <DrInfoSearch :queryParams="queryParams" :fullDate="fullDate"/>
    <DrInfoList :queryParams="queryParams" :fieldItems="fieldItems" :fullDate="fullDate"/>
  </div>
</template>
<script>


import contentStatUserInfoModal from './ContentStatUserInfoModal';
import DrInfoTop from "./component/DrInfo/DrInfoTop";
import DrInfoSearch from "./component/DrInfo/DrInfoSearch";
import DrInfoList from "./component/DrInfo/DrInfoList";
const moment = require("moment");

/*
Vue.filter('numberFormat', function(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return value.toLocaleString(); // 3자리 콤마 적용
});
*/


export default {
  components: {
    DrInfoList,
    DrInfoSearch,
    DrInfoTop,
    contentStatUserInfoModal
  },
  data() {
    return {
      fullDate: [],

      reportcode: '',

      excelTotalCnt: 0,

      queryParams: {
        keyword: '',
        dr_code: '',
        report_name: '',
        view_type: 'VIEW',

        start_date: '',
        end_date: '',
      },

      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
      }, {
        'user_id': {
          'label': '아이디',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'user_name': {
          'label': '이름',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'authority_name': {
          'label': '회원구분',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
          }
        }
      }, {
        'mobile': {
          'label': '핸드폰번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
          }
        },
      }, {
        'user_reg_date': {
          'label': '가입일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'total_cnt': {
          'class': 'text-center',
          'sortable': true,
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }],

    }
  },
  computed: {

  },

  mounted: function() {
    this.queryParams.dr_code = this.$session.get('reportDrcode');
    this.queryParams.report_name = this.$session.get('reportInfoName');
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
    chagefield(view_type){
      let label_nm = '';
      if (view_type == 'VIEW'){
        label_nm = '조회수';
      } else if (view_type == 'RECOMMAND'){
        label_nm = '추천수';
      } else if (view_type == 'DOWNLOAD'){
        label_nm = '다운로드수';
      } else if (view_type == 'RESEARCH'){
        label_nm = '후속연구요쳥수';
      }

      this.fieldItems = this.fieldItems.map(item => {
        if (item.hasOwnProperty('total_cnt')) {
          item.total_cnt.label = label_nm; // 'your_new_label'을 원하는 새로운 레이블로 바꾸세요.
        }
        return item;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/ContentStatisticsInfo.vue